module.exports = __webpack_public_path__ + "static/media/cvs-back.451b35c6.png";